import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  purchasedReceipts: null,
  soldReceipts: null,
  isLoading: false,
  error: null,
})

const transactions = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_PURCHASED_TRANSACTIONS:
      return state.set('purchasedReceipts', payload.receipts)
    case actions.SET_SOLD_TRANSACTIONS:
      return state.set('soldReceipts', payload.receipts)
    case actions.SET_TRANSACTIONS_IS_LOADING:
      return state.set('isLoading', payload)
    case actions.SET_TRANSACTION_ERROR:
      return state.set('error', payload)
    default:
      return state
  }
}

export default transactions
